import { ORDER_API_URL } from '../constants';
import { apiFetch } from './client';
import { stringifyOrdersParameters } from './orders';

export const getShipmentIssues = async (queryParams) => {
    const res = await apiFetch(`${ORDER_API_URL}/shipments/issues?${stringifyOrdersParameters(queryParams)}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const ignoreShipmentIssue = async ({ issueId, onSuccess }) => {
    const res = await apiFetch(`${ORDER_API_URL}/shipments/issues/${issueId}/ignore`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    const result = await res.json();
    if (onSuccess) onSuccess(result);
    return result;
};

export const voidShipmentInShipStation = async ({ shipmentId, onSuccess }) => {
    const res = await apiFetch(`${ORDER_API_URL}/shipments/${shipmentId}/shipstation/void`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        if (res.status === 404) {
            throw new Error('Shipment with such shipmentId not found');
        }
        if (res.status === 409) {
            throw new Error('Not approved in Shipstation');
        }
        if (res.status === 422) {
            throw new Error('Invalid shipstationShipmentId');
        }
        throw new Error('Server Error!');
    }
    const result = await res.json();
    if (onSuccess) onSuccess(result);
    return result;
};

export const createShipment = async (payload) => {
    const res = await apiFetch(`${ORDER_API_URL}/shipments`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload)
    });
    if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        const err = new Error(errorData.message || 'Server Error!');
        (err as any).errors = errorData.errors;
        throw err;
    }
    return await res.json();
};

export const recheckShipmentIssue = async ({ issueId, onSuccess }: { issueId: number, onSuccess?: (data: any) => void }) => {
    const res = await apiFetch(`${ORDER_API_URL}/shipments/issues/${issueId}/recheck`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.message || 'Server Error!');
    }
    const result = await res.json();
    if (onSuccess) onSuccess(result);
    return result;
};

export const getManualShipments = async (queryParams) => {
    const res = await apiFetch(`${ORDER_API_URL}/shipments?${stringifyOrdersParameters(queryParams)}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};
